import { Injectable, ErrorHandler } from '@angular/core';
import { environment, strings } from './../../../../environments/environment';
import { LocalStorageService } from '../local-storage/local-storage.service';


@Injectable()
export class ErrorReportingService implements ErrorHandler {
  constructor(
    private localStorage: LocalStorageService
  ) { }

  handleError(err: any, req?: any, res?: any): void {
    console.error(err);

    if (environment.production) {
      const user = this.localStorage.get('login');
    }
  }
}
